export const locale = {
  lang: 'en',
  data: {
    INVOICES: {},
  },
};
